<p-panel header="Decrypted Connection Settings" [toggleable]="false">
    <!--<div class="grid">
        <div class="col-12">
            <textarea [rows]="5"
                      [cols]="150"
                      pInputTextarea
                      autoResize="autoResize"
                      [(ngModel)]="myConnectionStrings"></textarea>
        </div>

        {{myConnectionStrings}}
    </div>-->
    <div class="grid">
        <div class="col-12">
            <span [innerHtml]="myConnectionStrings"></span>
        </div>

      
    </div>
    
</p-panel>
